<template>
    <MenuBase :hidden="props.hidden"   
        tooltip="Edit song" 
        :tooltipPosition="props.tooltipPosition" 
        :theme="props.theme" 
        :tooltipText="props.tooltipText"
        :active="active"
        @menuClick="editSong()">
        <PencilIcon class="size-6" />
    </MenuBase>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
import MenuBase from '@/components/common/menus/MenuBase.vue';
import { PencilIcon } from '@heroicons/vue/24/outline';
import { appEvents } from '@/store/app.events';

const emit = defineEmits(['editSong'])
const props = defineProps( {
    disabled: {
        type: Boolean,
        default: true
    },
    hidden: {
        type: Boolean,
        default: true
    },
    tooltipPosition: {
        type: String,
        default: 'top',
        validator: (value) => {
            return ['top', 'bottom', 'left', 'right'].includes(value);
        }
    }
})

const editSong = () => {
    emit('editSong');
    appEvents.emit('editSong');
}
</script>